import React, { Component } from 'react'

const SOURCING_URL = 'https://genhavensourcing.co.uk/';

export default class SourcingSection extends Component {
	render() {
		return (
			<section id="genhaven_sourcing" className="burger">
				<div className="container">
					<header className="section_heading">
						<div className="row">
							<div className="col-lg-6 col-md-8 col-sm-10 m-auto">
								<h2>Welcome to GenHaven!</h2>
								<p>For our latest updates and services, please visit GenHaven Sourcing.</p>
								<a href={SOURCING_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary mt-3">Visit GenHaven Sourcing</a>
							</div>
						</div>
					</header>
				</div>
			</section>
		)
	}
}
